import request from '@/utils/request'

let getData = {}
getData.url = 'https://cdn1-open.mokyun.com/'
// banner图
getData.getBanner = () => {
	return request({
    	url: 'mokyun/bannerlist',
    	method: 'get'
	})
}

// 获取服务信息
getData.getServe = () => {
	return request({
    	url: 'mokyun/information',
    	method: 'get'
	})
}

// 获取优质案例
getData.getCase = (size, page) => {
	let url
	size ==undefined||page ==undefined?url='mokyun/case':url=`mokyun/case/${size}/${page}`
	return request({
    	url: url,
    	method: 'get'
	})
}

// 获取优质客户
getData.getClient = () => {
	return request({
    	url: 'mokyun/customerpic',
    	method: 'get'
	})
}

// 获取招聘信息
getData.getEmployment = () => {
	return request({
    	url: 'mokyun/jobs',
    	method: 'get'
	})
}

// 提交需求
getData.subDemand = (obj) => {
	return request({
	    url: 'mokyun/demand',
		method: 'post',
		data: obj
	})
}

// 导航栏
getData.nav = () => {
	return request({
	    url: '/mokyun/nav',
		method: 'get'
	})
}

// 底部信息 
getData.getFooter = () => {
	return request({
	    url: '/mokyun/company',
		method: 'get'
	})
}

// 底部友情链接
getData.friendLink = () => {
	return request({
	    url: '/mokyun/link',
		method: 'get'
	})
}

// 顶部图文分开
getData.separateImg = () => {
	return request({
	    url: '/mokyun/navpic',
		method: 'get'
	})
}

// 获取实验室中间图片
getData.getLabImg = () => {
	return request({
	    url: '/mokyun/labpic',
		method: 'get'
	})
}

// 获取文章分类
getData.getArticleSort = () => {
	return request({
	    url: '/mokyun/labcate',
		method: 'get'
	})
}


// 获取文章信息(不分页)
getData.getArticle = () => {
	return request({
	    url: '/mokyun/labarticle/list',
		method: 'get'
	})
}

// 获取文章信息(分页)
getData.getArticlePag = (cate, num, page) => {
	return request({
	    url: `/mokyun/labarticle/${cate}/${num}/${page}`,
		method: 'get'
	})
}

// 获取单篇文章信息
getData.aloneArticle = (id) => {
	return request({
	    url: `/mokyun/labarticle/${id}`,
		method: 'get'
	})
}

// 点赞
getData.giveLike = (id) => {
	return request({
	    url: `/mokyun/likearticle/${id}`,
		method: 'get'
	})
}

// 取消点赞
getData.noLike = (id) => {
	return request({
	    url: `/mokyun/cancellikearticle/${id}`,
		method: 'get'
	})
}

// 刷新点赞数
getData.getNewLike = (id) => {
	return request({
	    url: `/mokyun/articleLike/${id}`,
		method: 'get'
	})
}

// 评论/回复评论
getData.setComment = (obj) => {
	return request({
	    url: '/mokyun/labarticle/comment',
		method: 'post',
		data: obj
	})
}

// 获取评论
getData.getComment = (id) => {
	return request({
	    url: `/mokyun/labarticle/commentlist/${id}`,
		method: 'get'
	})
}

// 获取头像
getData.getHeadPortrait = () =>{
	return request({
		url: `/mokyun/headimgurl`,
		method: 'get'
	})
}

// 推荐/热门文章
getData.hotArticle = () => {
	return request({
	    url: '/mokyun/side/list',
		method: 'get'
	})
}

// 推荐/热门文章
getData.seo = () => {
	return request({
	    url: '/mokyun/seo',
		method: 'get'
	})
}

export default getData



// WEBPACK FOOTER //
// ./src/api/getInfo.js